import JSONtheme from './theme.json'
import {Theme} from '@/lib/kepler/interfaces'

const theme: Theme = JSONtheme.theme
export const customCss: { [key: string]: object } = JSONtheme.customCss
export const gradientAngle: { [key: string]: number } = JSONtheme.gradientAngle
export const customClasses: { [key: string]: string[] } = JSONtheme.customClasses
export default theme
